var map = {
	"./greennote 10.svg": 247,
	"./greennote 4.svg": 179,
	"./greennote 5.svg": 248,
	"./greennote 6.svg": 249,
	"./greennote 7.svg": 250,
	"./greennote 8.svg": 251,
	"./greennote 9.svg": 252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;